import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Action } from "../../internal/Action.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
import { toFloatAsString } from "../../internal/utils/toFloatAsString.js";
/**
 * @description Specifies the dpr.
 * @memberOf Actions.Delivery
 * @extends SDK.Action
 * @see Visit {@link Actions.Delivery|Delivery} for an example
 */
var DeliveryDPRAction = /*#__PURE__*/function (_Action) {
  /**
   * Create a new DeliveryDPRAction
   * @param dprValue
   */
  function DeliveryDPRAction(dprValue) {
    var _this;
    _classCallCheck(this, DeliveryDPRAction);
    _this = _callSuper(this, DeliveryDPRAction);
    _this._actionModel = {
      actionType: 'dpr'
    };
    // toFloatAsString is used to ensure 1 turns into 1.0
    var dprAsFloat = toFloatAsString(dprValue);
    _this._actionModel.dpr = dprAsFloat;
    _this.addQualifier(new Qualifier('dpr', dprAsFloat));
    return _this;
  }
  _inherits(DeliveryDPRAction, _Action);
  return _createClass(DeliveryDPRAction, null, [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var dpr = actionModel.dpr;
      // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [actionModel])
      // This allows the inheriting classes to determine the class to be created
      return new this(dpr);
    }
  }]);
}(Action);
export { DeliveryDPRAction };